// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Selectors
import { getGridSize } from '../../../utils/grid/gridSizeSelector';
import { activePopupSelector } from '../../../components/popupPanel/popupOpenSelector';
import { getPlatformDetailsSelector } from '../../../platform/platformSelector';

// Actions
import { closePopup } from '../../../components/popupPanel/popupActions';

// Components
import FloatingPanel from '../../../components/tooltips/FloatingPanel';
import PopupPanelMouseManager from '../../../components/popupPanel/PopupPanelMouseManager';
import CommentThreadCollapsedPopupContent from './CommentThreadCollapsedPopupContent';

// Constants
import { TooltipAlignment, TooltipPositions } from '../../../components/tooltips/tooltipConstants';
import { MilanoteApplicationMode } from '../../../../common/platform/platformTypes';

// Style
import './CommentThreadCollapsedPopup.scss';

const DEFAULT_ARROW_STYLE = { transform: 'translate(0, 1px)' };

const mapStateToProps = createSelector(
    activePopupSelector,
    (state, ownProps) => ownProps.popupId,
    (state, ownProps) => ownProps.forcePopupOpen,
    getGridSize,
    getPlatformDetailsSelector,
    (popupState, popupId, forcePopupOpen, gridSize, platformDetails) => ({
        isPopupOpen: forcePopupOpen || popupState.has(popupId),
        gridSize,
        platformDetails,
    }),
);

const mapDispatchToProps = (dispatch) => ({
    dispatchClosePopup: (popupId) => dispatch(closePopup(popupId)),
});

const CommentThreadCollapsedPopup = (props) => {
    const {
        isPopupOpen,
        gridSize,
        popupId,
        dispatchClosePopup,
        platformDetails,
        popupCssSelector,
        offset = 0,
        arrowStyle = DEFAULT_ARROW_STYLE,
    } = props;

    if (!isPopupOpen) return null;

    const isMobileMode = platformDetails.appMode === MilanoteApplicationMode.mobile;

    return (
        <FloatingPanel
            selector={popupCssSelector || `.popup-trigger-${popupId} .pin-button`}
            className="CommentThreadCollapsedPopup light"
            arrowColor="var(--ws-comment-background)"
            arrowStrokeColor="var(--ui-background-primary)"
            arrowWidth={13}
            arrowHeight={8}
            arrowStrokeWidth={0}
            arrowStyle={arrowStyle}
            distance={15}
            offset={offset}
            position={isMobileMode ? TooltipPositions.BOTTOM : TooltipPositions.RIGHT}
            alignment={TooltipAlignment.START}
            gridSize={gridSize}
            platformDetails={platformDetails}
            responsive
            pollPosition
        >
            <PopupPanelMouseManager
                {...props}
                ignoredClicksSelector=".InlineComment,.DocumentModalSidebar,.Toolbar,.mention-suggestion-entry,.MentionSuggestionEntry"
                visible={isPopupOpen}
                popupId={popupId}
                closePopup={() => dispatchClosePopup(popupId)}
            >
                <CommentThreadCollapsedPopupContent {...props} />
            </PopupPanelMouseManager>
        </FloatingPanel>
    );
};

CommentThreadCollapsedPopup.propTypes = {
    popupCssSelector: PropTypes.string,
    offset: PropTypes.number,
    arrowStyle: PropTypes.object,

    isPopupOpen: PropTypes.bool,
    gridSize: PropTypes.number,
    popupId: PropTypes.string,
    elementId: PropTypes.string,
    threadId: PropTypes.string,
    element: PropTypes.object,
    currentBoardId: PropTypes.string,
    permissions: PropTypes.number,
    platformDetails: PropTypes.object,

    dispatchClosePopup: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentThreadCollapsedPopup);
